'use strict';

var CustomizeContext = require('../../../CustomizeContext-CpkrEQ6Z.js');
require('react');
require('./types.js');



exports.CustomizeContext = CustomizeContext.CustomizeContext;
exports.CustomizeContextProvider = CustomizeContext.CustomizeContextProvider;
//# sourceMappingURL=index.js.map
